'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _analyticsBot = require('./analytics-bot.html');

var _analyticsBot2 = _interopRequireDefault(_analyticsBot);

var _analyticsBot3 = require('./analytics-bot.controller');

var _analyticsBot4 = _interopRequireDefault(_analyticsBot3);

require('./analytics-bot.styl');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var analyticsComponent = {
  restrict: 'E',
  bindings: {},
  template: _analyticsBot2.default,
  controller: _analyticsBot4.default,
  controllerAs: 'vm'
};

exports.default = analyticsComponent;


/** WEBPACK FOOTER **
 ** ./client/app/containers/analytics-bot/analytics-bot.component.js
 **/